'use strict'

module.exports = {
  RESOLVE_DEPENDENCIES: 'RESOLVE_DEPENDENCIES',
  SET_DEPENDENCIES: 'SET_DEPENDENCIES',
  PERFORM_HANDSHAKES: 'PERFORM_HANDSHAKES',
  RESOLVE_MISSING_DEPENDENCIES: 'RESOLVE_MISSING_DEPENDENCIES'
}



// WEBPACK FOOTER //
// ./dependency-resolution/actionTypes.js